
const l10n: {[key in ShareOptionLangCode]: {btnShare: string, successMsg: string, btnClose: string}} = {
  ko: {
    btnShare: '공유',
    btnClose: '닫기',
    successMsg: 'URL이 복사되었습니다. 친구에게 공유해보세요.',
  },
  en: {
    btnShare: 'Share',
    btnClose: 'Close',
    successMsg: 'URL copied. Share it with your friends.',
  },
  ja: {
    btnShare: '共有',
    btnClose: 'Close',
    successMsg: 'アドレスがコピーされました。好きなところに貼り付けできます',
  },
  zh: {
    btnShare: '分享',
    btnClose: 'Close',
    successMsg: '已成功複製URL，向好友分享吧。',
  },
  ar: {
    btnShare: 'Share',
    btnClose: 'Close',
    successMsg: 'تم نسخ عنوان الـURL. قم بمشاركته مع أصدقائك.',
  }
};

export default l10n;
